// extracted by css-extract-rspack-plugin
export default {"tableLayoutFixed":"DiffLines-module__tableLayoutFixed__FACjYgy","compact":"DiffLines-module__compact__Z0caVUu"};